import React, { useEffect, useState, useContext } from 'react';
import { useParams } from 'react-router-dom';
import { Container, Typography, CircularProgress,Box, Button, Stack, FormControl, MenuItem, InputLabel, Select, TextField, Alert } from '@mui/material';
import ticketApi from '../../api/ticketApi';
import { AuthContext } from '../../auth/AuthContext';
import BackButtonDesktop from '../../components/BackButtonDesktop';
const extractErrorMessage = (error) => {
  if (!error) return 'Errore sconosciuto';
  if (error.response?.data) return JSON.stringify(error.response?.data);
  if (!error.response) {
    return "L'elaborazione richiede più tempo del previsto. Riprova.";
  }
  return error.message || JSON.stringify(error);
};
export default function TicketDetailPageMobile() {
  const { user } = useContext(AuthContext);
  const { id } = useParams();
  const [ticket, setTicket] = useState(null);
    const [loading, setLoading] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState([]); // ✅ AGGIUNTO
  const [message, setMessage] = useState('');
  const [error, setError] = useState(null);
  const [status, setStatus] = useState('');
  const [level, setLevel] = useState('');
  const STATI = ['APERTO','IN_LAVORAZIONE','CHIUSO'];
  const LIVELLI = ['PRIMO_LIVELLO','SECONDO_LIVELLO'];

  useEffect(() => {
    loadTicket();
  }, [id]);

  const loadTicket = async () => {
    setLoading(true);
    const res = await ticketApi.get(id);
    setTicket(res.data);
    setStatus(res.data.stato);
    setLevel(res.data.livello);
    setLoading(false);
  };

  const handleAddMessage = async () => {
    setLoading(true);
    const formData = new FormData();
    formData.append("message", message);

    selectedFiles.forEach(file => {
      formData.append("files", file);
    });

    await ticketApi.addMessage(id, formData);
    console.log("messaggio caricato");
    setMessage("");
    setSelectedFiles([]);
    setLoading(false);
    loadTicket();
  };

  const handleChangeStatus = async () => {
    try {
      await ticketApi.changeStatus(id, status);
      setTicket();
    } catch (err) {
      setError(err.response?.data || err.message);
    }
  };

  const handleChangeLevel = async () => {
    try {
      await ticketApi.changeLevel(id, level);
      setTicket();
    } catch (err) {
      setError(err.response?.data || err.message);
    }
  };

    const handleDownload = async (ticketId, attachment) => {
      const response = await ticketApi.downloadAttachment(
        ticketId,
        attachment.id
      );

      const blob = new Blob([response.data], {
        type: attachment.mimeType || "application/octet-stream"
      });

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", attachment.filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
    };

  if (!ticket) return <Container>Caricamento...</Container>;

  return (
    <Container>
        {loading && <Box sx={{ position: 'fixed', inset: 0, bgcolor: 'rgba(255,255,255,0.7)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1300 }}><CircularProgress size={48}/></Box>}
      {error && <Alert severity="error">{error}</Alert>}
      <Typography variant="h4">Ticket #{ticket.id}</Typography>
      <Typography>Oggetto: {ticket.oggetto}</Typography>
      <Typography>Stato: {ticket.stato}</Typography>
      <Typography>Livello: {ticket.livello}</Typography>
          {user.role === 'ADMIN' && (
            <>
             <FormControl size="small" sx={{ minWidth: 140 }}>
              <Select name="stato" value={status} onChange={(e) => setStatus(e.target.value)}
               label="Cambia stato">
                <MenuItem value=""><em>None</em></MenuItem>
                {STATI.map(s => <MenuItem key={s} value={s}>{s}</MenuItem>)}
              </Select>
            </FormControl>
              <Button variant="outlined" onClick={handleChangeStatus}>
                Aggiorna stato
              </Button>
              <FormControl size="small" sx={{ minWidth: 140 }}>
            <Select name="livello" value={level} onChange={(e) => setLevel(e.target.value)}
             label="Cambia livello">
              <MenuItem value=""><em>None</em></MenuItem>
              {LIVELLI.map(s => <MenuItem key={s} value={s}>{s}</MenuItem>)}
            </Select>
            </FormControl>
              <Button variant="outlined" onClick={handleChangeLevel}>
                Aggiorna livello
              </Button>
            </>
          )}
      <Stack spacing={2} sx={{ mt: 2 }}>
        <Typography variant="h6">Messaggi</Typography>

        {ticket.messages?.map((m) => (
          <Box key={m.id} sx={{ mb: 2 }}>
            <Typography>
              [{m.authorType}] {m.message}
            </Typography>

            {m.attachments?.map((a) => (
              <Button
                key={a.id}
                size="small"
                onClick={() => handleDownload(ticket.id, a)}
                sx={{ display: "block", mt: 0.5 }}
              >
                {a.filename}
              </Button>
            ))}
          </Box>
        ))}

        <TextField
          fullWidth
          multiline
          rows={3}
          value={message}
          onChange={(e) => setMessage(e.target.value)}
        />
      {/* UPLOAD FILE MULTIPLI */}
      <Stack direction="row" spacing={1}>
        <input
          type="file"
          multiple
          style={{ display: 'none' }}
          id="chat-file-upload"
          onChange={(e) => {
            const newFiles = Array.from(e.target.files);
            setSelectedFiles(prev => [...prev, ...newFiles]); // Accoda i file
          }}
        />
        <label htmlFor="chat-file-upload">
          <Button variant="outlined" component="span">
            {selectedFiles.length > 0
              ? `${selectedFiles.length} file selezionati`
              : 'Carica file'}
          </Button>
        </label>
        {selectedFiles.length > 0 && (
          <Stack spacing={0.5} sx={{ ml: 1 }}>
            {selectedFiles.map((file, index) => (
                <Stack key={index} direction="row" alignItems="center" spacing={0.5}>
                  <Typography variant="caption">{file.name}</Typography>
                  <Button
                    size="small"
                    color="error"
                    onClick={() => {
                      setSelectedFiles(prev => prev.filter((_, i) => i !== index));
                    }}
                  >
                    ✕
                  </Button>
                </Stack>
            ))}
          </Stack>
        )}
      </Stack>

        <Button
          variant="contained"
          sx={{ mt: 2, ml: 2 }}
          onClick={handleAddMessage}
        >
          Invia messaggio
        </Button>

      </Stack>
    </Container>
  );
}